import { useAuth } from '@restworld/feature-authentication';
import { Heading, Text } from '@restworld/ui-ds-base';
import NextLink from 'next/link';
import { useTranslation } from 'next-i18next';
import { cn } from '@restworld/utils-common';
export const Header = () => {
  const { t } = useTranslation('user-settings');
  const header = t('account_tab_header');
  const isLeadUserType = useAuth().user?.type === 'lead';
  const descriptionText = isLeadUserType
    ? `${t('account_tab_description_text').split('.')[0]}.`
    : t('account_tab_description_text');
  const link = !isLeadUserType && (
    <NextLink href="/profilo" className="text-primary-800 cursor-pointer underline">
      {t('account_tab_view_cv_text')}
    </NextLink>
  );
  return (
    <FlexCol>
      <TitleWrapper>
        <Heading size={1} className="hidden lg:block">
          {header}
        </Heading>
        <Heading size={5} className="lg:hidden">
          {header}
        </Heading>
      </TitleWrapper>
      <div className="lg:w-[42.438rem] w-full">
        <Heading color="muted-foreground" weight="normal" align="left" className="hidden lg:block">
          {descriptionText} {link}
        </Heading>
        <div className="lg:hidden block">
          <Text size={2} align="left">
            {descriptionText} {link}
          </Text>
        </div>
      </div>
    </FlexCol>
  );
};

export const FlexCol = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex flex-col', className)} {...props} />
);

export const TitleWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn('flex lg:flex-col flex-row lg:gap-4 gap-13.5 lg:items-start items-center', className)}
    {...props}
  />
);
